const e = "_section_10hhd_1", t = "_metaWrapper_10hhd_9", n = "_article_10hhd_15", o = "_contentWrapper_10hhd_19", _ = "_content_10hhd_19", c = "_preamble_10hhd_57", s = "_body_10hhd_61", p = "_sideComponents_10hhd_66", r = {
  section: e,
  metaWrapper: t,
  article: n,
  contentWrapper: o,
  content: _,
  preamble: c,
  body: s,
  sideComponents: p
};
export {
  n as article,
  s as body,
  _ as content,
  o as contentWrapper,
  r as default,
  t as metaWrapper,
  c as preamble,
  e as section,
  p as sideComponents
};
